import { render, staticRenderFns } from "./EditCarrier.vue?vue&type=template&id=5bbb3681&scoped=true&"
import script from "./EditCarrier.vue?vue&type=script&lang=js&"
export * from "./EditCarrier.vue?vue&type=script&lang=js&"
import style0 from "./EditCarrier.vue?vue&type=style&index=0&id=5bbb3681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb3681",
  null
  
)

export default component.exports